var translation = window['langArr'][window['language']];

function isInElectron() {
    if (/electron=true/.test(window.location.href)) {
        return true;
    }

    return false;
}

$(document).ready(function(){   

      /*   $('.terminal-left').height($('.terminal-content-tab').height() + $('.terminal-tabs').height());

        $( window ).resize(function() {
            $('.terminal-left').height($('.terminal-content-tab').height() + $('.terminal-tabs').height());
        });
      */

        // DISABLED
        // updateResults();

        /**
     * @descrition Rebet func must be global,
     * externally called from parent document.
     * @task Og 1106  Rebet global function
     **/
    function Rebet(ticketId) {
      dispatchEvent(new CustomEvent('on-rebet', {detail: {ticketId: ticketId}}));
      console.info('Rebet for ticketid: ' + ticketId);
    }
    window.Rebet = Rebet;

    window.addEventListener("message", function (event) {
      console.log("Detected post message from parent:", event.data.payload);
      if (event.data.action === "REBET") {
        // store.dispatch("callRebet", event.data?.payload);
        Rebet(event.data.payload)
      }
    });

    window.addEventListener('on-rebet', (e) => {
      if(typeof BaseConfig.rebetTicketData !== null) {
        getTicketById(e.detail.ticketId);
      } else {
        console.info("Something wrong in on-bet event.")
        return;
      }
    }, {passive: true});

    function getTicketById(ticketId) {
      var infoForm = new FormData();
      var sessionId = window['customLoggedIn'] && window['customToken'] ? window['customToken'] : window['token'];
      infoForm.append('SessionID', sessionId || '');
      infoForm.append('Referer', 'https://localhost');
      infoForm.append('ticketId', ticketId);
      getTicketByIdFetch(infoForm);
    }
    window.getTicketById = getTicketById;

    let BaseConfig = {
      // MAybe on public asunc DOM not ready ...
      LBCollections: document.getElementsByClassName('last-ball-color bhr-balls'),
      FBCollections: document.getElementsByClassName('first-ball-color bhr-balls'),
      ALLCollections: document.getElementsByClassName('top-color bhr-balls'),
      rebetTicketData: {},
      singleNumbers: [],
      forceProdcForLocalhost: false,
      // Proxy addresses
      proxyAddressProd: window['API_URL'],
      routeGetTicketById: '/luckyballs/ticket/get/id',
      getRouteGetTicketById: function() {
        if(BaseConfig.forceProdcForLocalhost == true) return BaseConfig.proxyAddressProd + BaseConfig.routeGetTicketById;
        if(location.host == 'online.elbetdev.com' ||
          location.host == 'webterminal.elbetdev.com' ||
          location.host.toString().indexOf('elbetdev.com') != -1) {
          return BaseConfig.proxyAddressProd + BaseConfig.routeGetTicketById;
        } else if(location.host != 'localhost' &&
          location.host != '127.0.0.1' &&
          location.host.toString().indexOf('localhost') != 0) {
          return BaseConfig.proxyAddressProd + BaseConfig.routeGetTicketById;
        } else {
          return BaseConfig.proxyAddressProd + BaseConfig.routeGetTicketById;
        }
      },
      detNumOfRound: function(ticketItemArray) {
        var detFirstTypeOfGame = '';
        if(ticketItemArray[0].Numbers == "") {
          detFirstTypeOfGame = ticketItemArray[0].Description;
        } else {
          detFirstTypeOfGame = ticketItemArray[0].Numbers;
        }
        var c = 1;
        ticketItemArray.forEach((ticketData, index) => {
          if(index > 0) {
            if(ticketData.Numbers == detFirstTypeOfGame || ticketData.Description == detFirstTypeOfGame) {
              c++;
            }
          }
        });
        return ticketItemArray.length / (ticketItemArray.length / c);
      }
    }
    window.BaseConfig = BaseConfig;

    // Collect DOMS
    for(var j = 0;j < 48;j++) {
      var mySufix = j + 1;
      BaseConfig.singleNumbers.push(byId('ball' + mySufix))
    }
    

    window.getTicketByIdFetch = function(infoForm) {
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = () => {
        if(xhttp.readyState == 4 && xhttp.status == 200) {
          handleGetTicketById(JSON.parse(xhttp.responseText));
        }
      };
      xhttp.open("POST", BaseConfig.getRouteGetTicketById(), true);
      xhttp.send(infoForm);
    }

    window.handleGetTicketById = function(response) {
      if(response.Status == 1) {
        handleRebetTicket(response.TicketData.TicketData);
      } else {
        console.warn("Something wrong with GetTicketById call. Please contact administrator.")
      }
    }

    var clearArray = function(handlerArr) {
      var newRes = [];
      handlerArr.forEach(
        function(element) {
          if(element != "") {
            newRes.push(element);
          }
        }
      );
      return newRes;
    }

    window.handleRebetTicket = function(data) {
      BaseConfig.rebetTicketData.selectedBalls = [];
      BaseConfig.rebetTicketData.numOfRounds = BaseConfig.detNumOfRound(data);
      data.forEach((ticketData) => {
        if(ticketData.Numbers && 
          ticketData.OddType != 10 && ticketData.OddType != 5 && ticketData.OddType != 7) {
          var detNums = clearArray(ticketData.Numbers.split('|'));
          BaseConfig.rebetTicketData.selectedBalls = detNums;
          BaseConfig.rebetTicketData.system = ticketData.Systems;
        }
        if(ticketData.Odd != null) {
          if(ticketData.OddType == 4) {
            BaseConfig.rebetTicketData.firstEvenOdd = ticketData.Odd;
          } else if(ticketData.OddType == 3) {
            BaseConfig.rebetTicketData.firstLessMore = ticketData.Odd;
          } else if(ticketData.OddType == 9) {
            BaseConfig.rebetTicketData.lastEvenOdd = ticketData.Odd;
          } else if(ticketData.OddType == 8) {
            BaseConfig.rebetTicketData.lastLessMore = ticketData.Odd;
          } else if(ticketData.OddType == 6) {
            BaseConfig.rebetTicketData.allEvenOdd = ticketData.Odd;
          } else if(ticketData.OddType == 2) {
            BaseConfig.rebetTicketData.F5LessMore = ticketData.Odd;
          } else if(ticketData.OddType == 10) {
            // here odd is not important , numbers come with info
            BaseConfig.rebetTicketData.lastBallColor = ticketData.Numbers.toString(10).replace(/\D/g, '0').split('').map(Number);
          }else if(ticketData.OddType == 5) {
            // here odd is not important , numbers come with info
            BaseConfig.rebetTicketData.firstBallColor = ticketData.Numbers.toString(10).replace(/\D/g, '0').split('').map(Number);
          }else if(ticketData.OddType == 7) {
            // here odd is not important , numbers come with info
            BaseConfig.rebetTicketData.allBallColor = ticketData.Numbers.toString(10).replace(/\D/g, '0').split('').map(Number);
          }
        }
      });
      // EQ with dispatchEvent(new CustomEvent('CLEAR', {}))
      dispatchEvent(new CustomEvent('CLEAR', {}))
      selectRebetTicketData();
    }

    function byId(id) {
      return document.getElementById(id)
    }
    window.byId = byId;

    function selectRebetTicketData() {
      byId('subscription-btn').value = BaseConfig.rebetTicketData.numOfRounds;
      if(BaseConfig.rebetTicketData.firstEvenOdd == 1) byId('firstballeven').click();
      if(BaseConfig.rebetTicketData.firstEvenOdd == 2) byId('firstballodd').click();
      if(BaseConfig.rebetTicketData.firstLessMore == 1) byId('firstballlessthan24').click();
      if(BaseConfig.rebetTicketData.firstLessMore == 2) byId('firstballmorethan24').click();
      if(BaseConfig.rebetTicketData.lastEvenOdd == 1) byId('lastballeven').click();
      if(BaseConfig.rebetTicketData.lastEvenOdd == 2) byId('lastballodd').click();
      if(BaseConfig.rebetTicketData.lastLessMore == 1) byId('lastballlessthan24').click();
      if(BaseConfig.rebetTicketData.lastLessMore == 2) byId('lastballmorethan24').click();
      if(BaseConfig.rebetTicketData.allEvenOdd == 1) byId('more-even').click();
      if(BaseConfig.rebetTicketData.allEvenOdd == 2) byId('more-odd').click();
      if(BaseConfig.rebetTicketData.F5LessMore == 1) byId('first5lessthan122').click();
      if(BaseConfig.rebetTicketData.F5LessMore == 2) byId('first5morethan122').click();
      if (typeof BaseConfig.rebetTicketData.lastBallColor !== 'undefined') {
        BaseConfig.rebetTicketData.lastBallColor.forEach((c, index)=> {
          BaseConfig.LBCollections[c-1].click()
        })
      }
      if (typeof BaseConfig.rebetTicketData.firstBallColor !== 'undefined') {
        BaseConfig.rebetTicketData.firstBallColor.forEach((c, index)=> {
          BaseConfig.FBCollections[c-1].click()
        })
      }
      if (typeof BaseConfig.rebetTicketData.allBallColor !== 'undefined') {
        BaseConfig.rebetTicketData.allBallColor.forEach((c, index)=> {
          BaseConfig.ALLCollections[c-1].click()
        })
      }
      BaseConfig.rebetTicketData.selectedBalls.forEach((num) => {
        // ROLE ball<NUMBER> in sufix
        BaseConfig.singleNumbers[num - 1].click();
      });
    }
    window.selectRebetTicketData = selectRebetTicketData;

        $('#betting-btn').click(function(){
                showNumpad( $(this));
        });

        $('#quick-lucky-balls').click(function(){
            $('#random-six-button').click();
            $('#buy-ticket-button').click();
        });
        
        if (isInElectron()) {
            $('body').click(function(){
                window.parent.postMessage({
                    eventName: 'last_click',
                    data: ''
                }, 'file://');
            });
            $('body').addClass('electron-true');
        }
    });

    document.onkeydown = function(event) {
        if (isInElectron()) {
            if (event.which == '13') {
                event.preventDefault();
            }
        }
    }

function showNumpad(elem){

    $('.numpad-overlay').click(function(){
        hideNumpad();
    })

    selectedNums = false;
    var total = 0;
    var arrValue = [];

    $('#numpad-title').text(translation['payment']);
    $('#numpad-title-value').text($('#betting-btn').val());

    $('*[data-predefined]').click(function(){
        selectedNums = false;
        arrValue = [];
        value = $(this).data('value');
        $('#numpad-title-value').text(Number(value).toFixed(2));
        $('#num-value').val(Number(value).toFixed(2));
    });

    $('*[data-num]').click(function(){
        if(!selectedNums){
            value = 0;
        }
        selectedNums = true;
        value = $(this).data('num');

        // Allow only two decimal places
        if ((total % 1) != 0 && $(this).data('numpad') != 'delete') {
            if(total.toString().split(".")[1].length == 2){
                return false;
            }
        }

        // Check if decimal place exist in array
        if($(this).data('num') === '.') {
            if(total == 0){
                return false;
            }
            if($.inArray(value, arrValue) >= 0) {
                return false;
            }
        }

        if($(this).data('numpad') == 'value'){
            if(total == 0 && value == 0){
                return false;
            }
            arrValue.push(value);
            total = arrValue.join(""); 
        }

        if($(this).data('numpad') == 'delete'){
            arrValue.splice(-1,1)
            total = arrValue.length == 0 ? 0 : arrValue.join(""); 
        }

        $('#numpad-title-value').text(Number(total).toFixed(2));
        $('#num-value').val(Number(total).toFixed(2));

        console.log(arrValue)
    })

    elem.blur();
    $('.numpad-overlay').show();
    $('#numpad').show();

    $('#numpad-ok').click(function(){
        $('#betting-btn').val($('#num-value').val());
        hideNumpad();
    });

    $('#numpad-buy').click(function(){
        $('#betting-btn').val($('#num-value').val());
        hideNumpad();
        $('#buy-ticket-button').click()
    });

    $(document).keydown(function(event) {
        console.log(event.key);
        switch (event.key) {
            case 'Enter':
                !isInElectron() ? $('#numpad-ok').click() : event.preventDefault();
                break;
            case '1':
                $('*[data-num="1"]').click();
                break;
            case '2':
                $('*[data-num="2"]').click();
                break;
            case '3':
                $('*[data-num="3"]').click();
                break;
            case '4':
                $('*[data-num="4"]').click();
                break;
            case '5':
                $('*[data-num="5"]').click();
                break;
            case '6':
                $('*[data-num="6"]').click();
                break;
            case '7':
                $('*[data-num="7"]').click();
                break;
            case '8':
                $('*[data-num="8"]').click();
                break;
            case '9':
               $('*[data-num="9"]').click();
                break;
            case '0':
                $('*[data-num="0"]').click();
                break;
            case '.':
                $('*[data-num="."]').click();
                break;
            case ',':
                $('*[data-num="."]').click();
                break;
            case 'Backspace':
                $('*[data-num="delete"]').click();
                break;
        }
    });
}

function hideNumpad(){
    $('.numpad-overlay').hide();
    $('#numpad').hide();
}



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/terminal.js
// module id = 878
// module chunks = 0